import * as createInvitation from 'store/actions/accounts/invitations/createInvitation';
import * as deleteInvitation from 'store/actions/accounts/invitations/deleteInvitations';
import * as fetchInvitations from 'store/actions/accounts/invitations/fetchInvitations';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* createInvitationAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/current-account/invitations`;

        const response = yield apiClient.create(url, values);

        yield put(createInvitation.createInvitationSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(createInvitation.createInvitationFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* createInvitationSuccessAsync() {
    yield put(showNotification('notifications.invitations.created', 'success'));
}

function* failureMessage({ payload }) {
    const { message } = payload.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

function* fetchInvitationsAsync({ payload }) {
    const {
        onError,
        onSuccess,
    } = payload;

    try {

        const url = `${ config.getApiBaseUrl() }/current-account/invitations`;

        const response = yield apiClient.read(url);

        yield put(fetchInvitations.fetchInvitationsSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(fetchInvitations.fetchInvitationsFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* deleteInvitationAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/current-account/invitations/${ id }`;

        yield apiClient.delete(url);

        yield put(deleteInvitation.deleteInvitationSuccess(payload));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess();
        }
    } catch (error) {
        yield put(deleteInvitation.deleteInvitationFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* deleteInvitationSuccessAsync() {
    yield put(showNotification('notifications.invitations.deleted', 'success'));
}

export default function* invitationsSagas() {
    yield [
        takeEvery(types.FETCH_INVITATIONS, fetchInvitationsAsync),
        takeEvery(types.FETCH_INVITATIONS_FAILURE, failureMessage),

        takeEvery(types.CREATE_INVITATION, createInvitationAsync),
        takeEvery(types.CREATE_INVITATION_FAILURE, failureMessage),
        takeEvery(types.CREATE_INVITATION_SUCCESS, createInvitationSuccessAsync),

        takeEvery(types.DELETE_INVITATION, deleteInvitationAsync),
        takeEvery(types.DELETE_INVITATION_FAILURE, failureMessage),
        takeEvery(types.DELETE_INVITATION_SUCCESS, deleteInvitationSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/accountInvitationsSagas.js